module.exports = __webpack_public_path__ + "img/time-log-empty.f6b40a3a.svg";